









import { Component, Prop, Vue } from 'vue-property-decorator';
import railwayInterface from '../interface/railway';

@Component({})
export default class Train extends Vue {
  @Prop({ default: [] }) private train!: railwayInterface['train'];
}
